export type StepStatus = 'pending' | 'running' | 'success' | 'error' | 'skipped'

export const STATUS_VARIANT: Record<StepStatus, string> = {
    pending: 'light',
    running: 'primary',
    success: 'success',
    error: 'danger',
    skipped: 'secondary',
}

export function errorMessage(error: any) {
    return error?.data?.error || error?.data?.message || error?.message || JSON.stringify(error)
}
